module.exports = __webpack_public_path__ + "static/media/Cardo-Bold.8cd7c282.eot";